const attendanceShiftsMock = [
    {
        id: 1,
        user_id: 101,
        ee_id: 400,
        worker: { id: 101, name: "Hans", surname: "Mueller" },
        subcontractor: { id: 11, title: "Messe Bau GmbH" },
        check_in_at: "2026-05-30 07:12:44",
        check_out_at: "2026-05-30 12:18:09",
        created_at: "2026-05-30 07:12:44",
        updated_at: "2026-05-30 12:18:09",
    },
    {
        id: 2,
        user_id: 101,
        ee_id: 400,
        worker: { id: 101, name: "Hans", surname: "Mueller" },
        subcontractor: { id: 11, title: "Messe Bau GmbH" },
        check_in_at: "2026-05-30 13:02:11",
        check_out_at: "2026-05-30 17:46:18",
        created_at: "2026-05-30 13:02:11",
        updated_at: "2026-05-30 17:46:18",
    },
    {
        id: 3,
        user_id: 102,
        ee_id: 400,
        worker: { id: 102, name: "Anna", surname: "Schneider" },
        subcontractor: { id: 12, title: "Logistics Team A" },
        check_in_at: "2026-05-30 07:25:19",
        check_out_at: "2026-05-30 12:05:10",
        created_at: "2026-05-30 07:25:19",
        updated_at: "2026-05-30 12:05:10",
    },
    {
        id: 4,
        user_id: 102,
        ee_id: 400,
        worker: { id: 102, name: "Anna", surname: "Schneider" },
        subcontractor: { id: 12, title: "Logistics Team A" },
        check_in_at: "2026-05-30 12:45:02",
        check_out_at: "2026-05-30 18:02:31",
        created_at: "2026-05-30 12:45:02",
        updated_at: "2026-05-30 18:02:31",
    },
    {
        id: 5,
        user_id: 103,
        ee_id: 400,
        worker: { id: 103, name: "Lukas", surname: "Fischer" },
        subcontractor: { id: 13, title: "Leipzig Montage GmbH" },
        check_in_at: "2026-05-31 06:44:08",
        check_out_at: null,
        created_at: "2026-05-31 06:44:08",
        updated_at: "2026-05-31 06:44:08",
    },
    {
        id: 6,
        user_id: 104,
        ee_id: 400,
        worker: { id: 104, name: "Svenja", surname: "Krause" },
        subcontractor: { id: 14, title: "Elektro Schmidt GmbH" },
        check_in_at: "2026-05-31 06:58:33",
        check_out_at: "2026-05-31 16:35:40",
        created_at: "2026-05-31 06:58:33",
        updated_at: "2026-05-31 16:35:40",
    },
    {
        id: 7,
        user_id: 105,
        ee_id: 400,
        worker: { id: 105, name: "Tobias", surname: "Richter" },
        subcontractor: { id: 11, title: "Messe Bau GmbH" },
        check_in_at: "2026-05-31 07:08:55",
        check_out_at: null,
        created_at: "2026-05-31 07:08:55",
        updated_at: "2026-05-31 07:10:21",
    },
    {
        id: 8,
        user_id: 106,
        ee_id: 400,
        worker: { id: 106, name: "Klara", surname: "Hoffmann" },
        subcontractor: { id: 12, title: "Logistics Team A" },
        check_in_at: "2026-06-01 06:37:24",
        check_out_at: "2026-06-01 15:59:12",
        created_at: "2026-06-01 06:37:24",
        updated_at: "2026-06-01 15:59:12",
    },
];

export default attendanceShiftsMock;
